'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';
import {
    SET_FUNCTIONS_VISTA_DE_USUARIOS,
    GET_DATA_VISTA_USUARIOS_START,
    GET_DATA_VISTA_USUARIOS_SUCCESS,
    SET_SELECTED_USER_ID,
    GET_DATA_ESTADO_USUARIOS_SUCCESS,
    SET_INGRESA_MOTIVO_BLOQUEADO,
    RESET_STATE_VISTA_USUARIOS,
    GET_DATA_AD_VISTA_USUARIOS
} from '../../Screens/VistaDeUsuario/actions/VistaDeUsuario';

const initialState = {
    isFetching: true,
    currentUser: undefined,
    functions: undefined,
    selectedUserId: undefined,
    usuario: undefined,
    perfiles: [],
    permisos: [],
    permisosParaMostrar: [],
    modoExclusivo: undefined,
    accesosSimultaneos: undefined,
    ultimoIngreso: undefined,
    ingresaMotivoBloqueado: true,
    estadoActual: undefined,
    gruposWindows: [],
    configuracionPwType: {}
};

/**
 * Reducer de vista de usuario
 * @param {any} state
 * @param {any} action
 */
function vistaDeUsuario(state = initialState, action) {
    LogHelper.In(vistaDeUsuario.name, state, action);

    let result;
    let usuariosFiltrados, usuariosTemp, temp = null;
    let usuariosSeleccionadosTemp = [];
    let tempResult;

    switch (action.type) {

        case SET_FUNCTIONS_VISTA_DE_USUARIOS:
            LogHelper.In(vistaDeUsuario.name, state, action);

            result = {
                ...state,
                functions: action.functions
            };
            break;

        case SET_SELECTED_USER_ID:
            LogHelper.In(vistaDeUsuario.name, state, action);

            result = {
                ...state,
                selectedUserId: action.selectedUserId
            };
            break;

        case GET_DATA_VISTA_USUARIOS_START:
            LogHelper.In(vistaDeUsuario.name, state, action);

            result = {
                ...state,
                currentUser: action.currentUser,
                isFetching: true
            };
            break;

        case GET_DATA_VISTA_USUARIOS_SUCCESS:
            LogHelper.In(vistaDeUsuario.name, state, action);

            tempResult = action.result;
            let fetching = tempResult.CONFIGURATION_PASSWORD_TYPE.AltaAutomatica;

            result = {
                ...state,
                isFetching: fetching,
                usuario: tempResult.USUARIO[0],
                perfiles: tempResult.PERFILES,
                permisos: tempResult.PERMISOS,
                permisosParaMostrar: tempResult.PERMISOS_PARA_MOSTRAR,
                modoExclusivo: tempResult.MODO_EXCLUSIVO,
                accesosSimultaneos: tempResult.ACCESOS_SIMULTANEOS,
                ultimoIngreso: tempResult.ULTIMO_INGRESO[0],
                ingresaMotivoBloqueado: tempResult.INGRESA_MOTIVO_BLOQUEADO,
                estadoActual: tempResult.ESTADO_ACTUAL,
                gruposWindows: tempResult.GRUPOS_WINDOWS,
                configuracionPwType: tempResult.CONFIGURATION_PASSWORD_TYPE
            };
            break;

        case GET_DATA_AD_VISTA_USUARIOS:
            LogHelper.In(vistaDeUsuario.name, state, action);

            result = {                
                ...state,
                isFetching: false,
                gruposWindows: action.gruposWindows
            };
            break;

        case GET_DATA_ESTADO_USUARIOS_SUCCESS:
            LogHelper.In(vistaDeUsuario.name, state, action);

            tempResult = action.result;

            result = {
                ...state,
                usuario: tempResult.USUARIO[0],
                estadoActual: tempResult.ESTADO_ACTUAL
            };
            break;

        case SET_INGRESA_MOTIVO_BLOQUEADO:
            LogHelper.In(vistaDeUsuario.name, state, action);

            result = {
                ...state,
                ingresaMotivoBloqueado: action.ingresaMotivoBloqueado
            };
            break;

        case RESET_STATE_VISTA_USUARIOS:
            LogHelper.In(vistaDeUsuario.name, state, action);

            result = initialState;
            break;

        default:
            LogHelper.In(vistaDeUsuario.name, state, action);
            result = {
                ...state
            }
            break;
    }

    LogHelper.Out(vistaDeUsuario.name, result);
    return result;
}

export default vistaDeUsuario;